// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"49d38e99","551":"5c92d3f6","672":"02b3c41a","842":"bda5687e"}[chunkId] + ".chunk.js";
};